import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: import.meta.env.VITE_APP_GTM_ID!,
};

export const initGTM = () => {
  if (!window.location.pathname.includes("web-form")) {
    TagManager.initialize(tagManagerArgs);
  }
};
